import { connect } from 'react-redux';
import { attSubPage } from 'decorators/subPage';

import { fetchAttOutstandingLeases } from 'actions/attLeases';
import { createSub } from 'actions/attSubs';
import { fetchAttSubLeases as fetchOwing, transferLease } from 'api';
import {
  findAttSub,
  expireAttSubscription,
  updateAttMdn,
} from 'actions/attSubs';
import { fetchUserOverduePurchases } from 'actions/purchases';
import {
  getIsAdmin,
  getAttOutstandingLeases,
  getOverduePurchases,
  getCreatedAttSub,
  getSubmitStatus,
} from 'reducers';
import CreateNewSubComponent from 'components/ChangeMDNNewSubForm/att';

import ChangeMDN from './ChangeMDN';

const mapStateToProps = (state) => ({
  isAdmin: getIsAdmin(state),
  leases: getAttOutstandingLeases(state),
  overduePurchases: getOverduePurchases(state),
  CreateNewSubComponent,
  newSub: getCreatedAttSub(state),
  changeMdnSaveStatus: getSubmitStatus(state, 'changeMdn'),
  createSub,
  fetchOwing,
  redirectUrl: (subId) => `/att/subscription/${subId}/view`,
  transferLease: (leaseId, subId) =>
    transferLease(leaseId, {
      att_subscription: subId,
    }),
});

const mapDispatchToProps = {
  findSub: findAttSub,
  fetchOwingAction: fetchAttOutstandingLeases,
  fetchUserOverduePurchases,
  expireSubscription: expireAttSubscription,
  updateMdn: updateAttMdn,
};

export default attSubPage(
  connect(mapStateToProps, mapDispatchToProps)(ChangeMDN),
);
